import { Col, Row, TitleText } from '@policygenius/mortar';
import { createUseStyles } from 'react-jss';

import styles from './styles';
import { InputRecommendationCardProps } from './types';

const useStyles = createUseStyles(styles);

const InputRecommendationCard: React.FC<InputRecommendationCardProps> = ({
  leftPaneBody,
  leftPaneCentered,
  rightPaneTitle,
  rightPaneBody,
}) => {
  const classes = useStyles({ leftPaneCentered });

  return (
    <Row className={classes.card}>
      <Col className={classes.leftPane} span={{ small: 4, medium: 5 }}>
        {leftPaneBody}
      </Col>
      <Col className={classes.rightPane} span={{ small: 4, medium: 7 }}>
        <TitleText className={classes.rightPaneTitle} as="h4" size="medium">
          {rightPaneTitle}
        </TitleText>
        {rightPaneBody}
      </Col>
    </Row>
  );
};

export default InputRecommendationCard;
